<div class="container">
    <div class="row no-gutters">
        <div class="col-12">
            <div class="d-flex popup-head align-items-center" *ngIf="fromVehicleScreen">
                <div class="popup-title mr-auto" translate>
                    lblCustomerSelection
                </div>

                <div class="float-right">
                    <a class="close mr-3" (click)="OnClose()" translate>
                        <span class="" aria-hidden="true">&times;</span>
                    </a>
                </div>
            </div>
            <!-- Quick search strart -->
            <div class="subheader with-padding flgrow">
                <div class="row align-items-center">
                    <div class="col-6 col-lg-3">
                        <div class="d-flex">
                            <div class="flex-grow-1">
                                <div class="input-group">
                                    <input class="form-control" type="text" name="searchTerm"
                                        placeholder="{{ 'lblSearch' | translate }}" [(ngModel)]="searchTerm"
                                        autocomplete="off" (keyup.enter)="onSearchFilter()" />
                                    <div class="input-group-append">
                                        <button type="button" class="btn btn-primary" (click)="onSearchFilter()">
                                            <em class="fa fa-search"></em>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <!-- Quick search End -->

                            <!-- Advance search start -->
                            <div class="ml-2 advanced-search-box">
                                <button type="button" class="btn btn-primary px-2-5" (click)="onSearch()"
                                    aria-label="Center Align">
                                    <em class="fa fa-search-plus" aria-hidden="true"></em>
                                </button>
                                <div class="searchbox card fix lt" *ngIf="isAdvanceSearch">
                                    <div class="form-row mb-3">
                                        <div class="col" *ngIf="allowCompanyCreation">
                                            <div class="custom-control custom-checkbox mt-25">
                                                <input class="custom-control-input" type="checkbox"
                                                    [checked]="companyShow" id="customCheck1"
                                                    (change)="changeCustomerType($event)" />
                                                <label class="custom-control-label" style="line-height: 25px;"
                                                    for="customCheck1" translate>lblCompany</label>
                                            </div>
                                        </div>
                                        <div class="col" *ngIf="!companyShow">
                                            <label for="template-firstName" translate>lblFirstName </label>
                                            <div class='lbl-info'>
                                                <input type="text" id="template-firstName" name="firstName"
                                                    [(ngModel)]="customerListRequest.firstName"
                                                    class="form-control" maxlength="100">
                                            </div>
                                        </div>
                                        <div class="col" *ngIf="!companyShow">
                                            <label for="template-lastName" translate>lblLastName </label>
                                            <div class='lbl-info'>
                                                <input type="text" id="template-lastName" name="lastName"
                                                    [(ngModel)]="customerListRequest.lastName"
                                                    class="form-control" maxlength="100">
                                            </div>
                                        </div>
                                        <div class="col" *ngIf="companyShow">
                                            <label for="template-customerName" translate>lblCompanyName</label>
                                            <div class='cust_name'>
                                                <input type="text" id="template-customerName" name="customerName"
                                                    [(ngModel)]="service.customerListRequest.customerName"
                                                    class="form-control" maxlength="100">
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row mb-3">
                                        <div class="col">
                                            <label for="template-customerNo" translate>lblCustomerNumber</label>
                                            <input type="text" id="template-customerNo" name="customerNo"
                                                [(ngModel)]="customerListRequest.customerNo"
                                                class="form-control" />
                                        </div>
                                        <div class="col">
                                            <label for="template-customerGroup" translate>lblCustomerGroup</label>
                                            <div class='lbl-info'>
                                                <ng-select name="customerGroup"
                                                    placeholder="{{ 'lblSelectCustomerGroup' | translate }}"
                                                    [(ngModel)]="customerListRequest.customerGroup">
                                                    <ng-template ng-header-tmp>
                                                        <span class="mbold w-66px">Code</span>
                                                        <span class="mbold" translate>lblCustomerGroup</span>
                                                    </ng-template>
                                                    <ng-option *ngFor="let item of customerGroupList"
                                                        [value]="item.code">
                                                        <span class="w-66px">{{item.code}}</span>
                                                        <span class="mx-2 hide-ng-dropdown-panel">-</span>
                                                        <span>{{item.description}}</span>
                                                    </ng-option>
                                                </ng-select>
                                            </div>
                                        </div>
                                        <div class="col" style="display: none;">
                                            <label for="template-salutation" translate>lblSalutation</label>
                                            <div class='lbl-info'>
                                                <ng-select name="salutation"
                                                    placeholder="{{ 'lblSelectSalutation' | translate }}"
                                                    [(ngModel)]="customerListRequest.salutation">
                                                    <ng-template ng-header-tmp>
                                                        <span class="mbold w-66px">Code</span>
                                                        <span class="mbold" translate>lblSalutation</span>
                                                    </ng-template>

                                                    <ng-option *ngFor="let item of addressSalutationList"
                                                        [value]="item.code">
                                                        <span class="w-66px">{{item.code}}</span>
                                                        <span class="mx-2 hide-ng-dropdown-panel">-</span>
                                                        <span>{{item.description}}</span>
                                                    </ng-option>
                                                </ng-select>
                                            </div>
                                        </div>
                                        <div class="col">
                                            <label for="template-postcode" translate>lblPostCode</label>
                                            <div class='lbl-info'>
                                                <ng-select name="postCode"
                                                    placeholder="{{ 'lblSelectPostCode' | translate }}"
                                                    [(ngModel)]="customerListRequest.postCode"
                                                    [virtualScroll]="true" (change)="onPostCodeSelected($event)">
                                                    <ng-option *ngFor="let item of postCodeList" [value]="item.code">
                                                        {{item.code}}</ng-option>
                                                </ng-select>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row mb-3">
                                        <div class="col-md-4">
                                            <label for="template-city" translate>lblCity </label>
                                            <div class='lbl-info'>
                                                <ng-select id="template-city" name="city"
                                                    placeholder="{{ 'lblSelectCity' | translate }}"
                                                    [(ngModel)]="customerListRequest.city"
                                                    (change)="onCitySelected($event)">
                                                    <ng-option *ngFor="let item of cityList" [value]="item">
                                                        {{item}}</ng-option>
                                                </ng-select>
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <label for="template-email"><span translate>lblEmail</span></label>
                                            <div class="lbl-info">
                                                <input id="template-email" name="email" maxlength="50"
                                                    [(ngModel)]="customerListRequest.email"
                                                    class="form-control mb-2">
                                            </div>
                                        </div>
                                        <div class="col-md-4">
                                            <label for="template-mobile"><span translate>lblMobile</span></label>
                                            <div class="lbl-info">
                                                <input class="form-control" type="text" id="template-mobile"
                                                    name="mobile" [(ngModel)]="customerListRequest.mobile"
                                                    (keypress)="isDigit($event)" maxlength="15" autocomplete="off" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="form-row mb-3">
                                        <div class="col-md-4">
                                            <label translate>lblRegNumber</label>
                                            <input class="form-control" type="text" name="licensePlateNo"
                                                [(ngModel)]="customerListRequest.licensePlateNo" maxlength="10"
                                                autocomplete="off" />
                                        </div>
                                        <div class="col-md-4">
                                            <label for="template-email"><span translate>lblSource</span></label>
                                            <div class="lbl-info">
                                                <ng-multiselect-dropdown [settings]="dropdownSettings"
                                                    [data]="applicationSourceList"
                                                    placeholder="{{ 'lblSource'| translate}}"
                                                    [(ngModel)]="selectedItems">
                                                </ng-multiselect-dropdown>
                                            </div>
                                        </div>
                                        <div class='col-md-4' *ngIf="dealerList && dealerList.length > 0">
                                            <label translate>lblSelectDealer</label>
                                            <app-dealer-searchbox-dropdown [dealerList]="dealerList" 
                                                ngDefaultControl name="advanceDealerDropdown" [selectedDealer]="selectedDealerId"
                                                (onSelectDealer)="onDealerSelected($event,'advanceSearchDealerDropdown')"
                                                placeholder="Search Dealer">
                                            </app-dealer-searchbox-dropdown>
                                        </div>
                                    </div>

                                    <hr />
                                    <div class="row">
                                        <div class="col text-right">
                                            <button type="submit" (click)="OpenSaveSearchModal(SaveSearchContent)"
                                                aria-label="Center Align" class="btn btn-primary mr-sm-3"
                                                translate>lblSaveFilter
                                            </button>
                                            <button type="submit" (click)="onApplyFilter()"
                                                class="btn btn-primary mr-sm-3" translate>lblApply
                                            </button>
                                            <button (click)="onReset()" class="btn btn-outline-tertiary mr-sm-3"
                                                translate>lblReset
                                            </button>
                                            <button (click)="onClose()" class="btn btn-outline-tertiary"
                                                translate>lblClose
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-auto pl-0">
                        <button type="submit" (click)="OpenSavedSearchListPopup()" class="btn btn-primary" translate
                            aria-label="Center Align">lblSavedFilters</button>
                    </div>
                    <div class="col-lg-2 col-md-3 col-sm-6 pl-4">
                        <ng-select placeholder="{{ 'lblStatus' | translate }}" [(ngModel)]="selectedStatus"
                            (change)="StatusChange($event)">
                            <ng-option *ngFor="let status of StatusList" [value]="status.id">
                                {{status.value}}
                            </ng-option>
                        </ng-select>
                    </div>

                    <!-- Quick search End -->

                    <!-- Export button section start -->
                    <div
                        class="col-3 col-lg-3 ml-auto d-flex flex-sm-row flex-column justify-content-end align-items-center">
                        <a *ngIf="!fromVehicleScreen" class="ml-2 btn btn-outline-primary" href="javascript:void(0);"
                            (click)="onRefresh()" aria-label="Center Align">
                            <em class="fas fa-sync fa-lg"></em>
                        </a>
                    </div>
                    <!-- Export button section start -->
                </div>

            </div>
            <!-- soft deleted Customer listing start  -->
            <div class="container prel">
                <div class="row">
                    <div class="c12">
                        <div class="card mb-3 scrollbar " [ngClass]="fromVehicleScreen? 'customerTab': ''">
                            <div class="card-header d-flex justify-content-between" translate>
                                lblDeletedCustomers
                                <div class="font16 fontbold">
                                    <span class="font16 fontnormal" translate>lblTotal</span>:&nbsp;{{
                                    totalCount
                                    }}&nbsp;<span class="font16 fontnormal" translate>lblResults</span>
                                </div>
                            </div>
                            <div class="table-responsive max-h254" infinite-scroll
                                [infiniteScrollDistance]="scrollDistance" [infiniteScrollThrottle]="throttle"
                                [scrollWindow]="false" (scrolled)="onScrollDown($event)">
                                <table class="tablest1">
                                    <thead>
                                        <tr>
                                            <th scope="col" translate class="text-center" *ngIf="fromVehicleScreen">
                                                lblSelect</th>
                                            <th style="width:55px" scope="col" translate>#</th>
                                            <th scope="col" sortable="customerType" (sort)="onSort($event)" translate
                                                *ngIf="allowCompanyCreation">
                                                lblType</th>
                                            <th scope="col" sortable="customerNo" (sort)="onSort($event)" translate>
                                                lblCustomerNumber</th>
                                            <th scope="col" sortable="customerName" (sort)="onSort($event)" translate>
                                                lblCustomerName</th>
                                            <th scope="col" sortable="pincode" (sort)="onSort($event)" translate>
                                                lblAddress</th>
                                            <th scope="col" sortable="preferredDealerName" (sort)="onSort($event)"
                                                translate>
                                                lblDealersName</th>
                                            <th scope="col" sortable="noOfVehicle" (sort)="onSort($event)"
                                                class="text-center" translate>lblVehicles</th>
                                            <th scope="col" translate>lblSource</th>
                                            <th scope="col" style="width:50px" sortable="updatedDate"
                                                (sort)="onSort($event)" translate>lblUpdatedDate</th>
                                            <th scope="col" style="width:50px" sortable="dmsSyncDate"
                                                (sort)="onSort($event)" translate *ngIf="IsDMS">lbllastSyncdate</th>
                                            <th class="text-center" scope="col" translate>lblActive</th>
                                            <th scope="col" translate class="text-center" *ngIf="!fromVehicleScreen">
                                                lblAction</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngIf="customerList?.length>0; else load_NotFound_Template">
                                            <tr *ngFor="let item of customerList; let i=index"
                                                [ngClass]="{'clrRed' : item.dmsSyncStatus == 0}">
                                                <td class="nowrap text-center vertical-middle"
                                                    *ngIf="fromVehicleScreen">
                                                    <input name="Search" type="radio" [(ngModel)]="selectedCustomerId"
                                                        class="radio-custom" [value]="item.id" />
                                                </td>
                                                <td>{{ item.rowNumber }}</td>
                                                <td *ngIf="allowCompanyCreation">
                                                    <ngb-highlight [result]="item.customerType">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    <ngb-highlight [result]="item.customerNo">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    <ngb-highlight class="fs-14px semibold lh-18px "
                                                        [result]="item.firstName">
                                                    </ngb-highlight>
                                                    <ngb-highlight class="fs-14px semibold lh-18px"
                                                        [result]="item.lastName" style="margin-left: 5px;">
                                                    </ngb-highlight>
                                                    <div class="d-flex align-items-center mt-1 fs-12px lh-16px"
                                                        *ngIf="item.mobileNo">
                                                        <em _ngcontent-xdg-c220=""
                                                            class="fas fa-phone-flip fs-10px fa-lg mr-2 clr666"></em>
                                                        <span class="fs-12px"
                                                            *ngIf="item.mobileCode">{{item.mobileCode}}-</span>
                                                        <ngb-highlight class="fs-12px" [result]="item.mobileNo">
                                                        </ngb-highlight>
                                                    </div>
                                                    <div class="d-flex align-items-center" *ngIf="item.email">
                                                        <em _ngcontent-xdg-c220=""
                                                            class="fas fa-envelope fs-10px fa-lg mr-2 clr666"></em>
                                                        <ngb-highlight class="fs-12px" [result]="item.email">
                                                        </ngb-highlight>
                                                    </div>
                                                </td>

                                                <td>
                                                    <ngb-highlight [result]="item.addressLine1">
                                                    </ngb-highlight>
                                                    <div class="d-flex align-items-center mt-1 fs-12px lh-16px">
                                                        <ngb-highlight class="fs-12px mr-2" [result]="item.pincode">
                                                        </ngb-highlight>
                                                        <ngb-highlight class="fs-12px" [result]="item.city">
                                                        </ngb-highlight>
                                                    </div>
                                                    <div class="d-flex align-items-center">
                                                        <ngb-highlight class="fs-12px" [result]="item.country">
                                                        </ngb-highlight>
                                                    </div>
                                                </td>
                                                <td>
                                                    <ngb-highlight [result]="item.preferredDealerName">
                                                    </ngb-highlight>
                                                </td>
                                                <td class="text-center">
                                                    <ngb-highlight [result]="item.noOfVehicle">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    <ngb-highlight
                                                        [ngClass]="item.sourceType ? 'flmid sourceBox rounded-0 justify-content-center' : ''"
                                                        [result]="item.sourceType">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    {{ item.updatedDate | date:'short'}}
                                                </td>
                                                <td *ngIf="IsDMS">
                                                    {{ item.dmsSyncDate | date:'short'}}
                                                </td>
                                                <td class="text-center">
                                                    <em class="fas fa-check" *ngIf="item.isActive == true"></em>
                                                    <em class="fas fa-close" *ngIf="item.isActive == false"></em>
                                                </td>

                                                <td class="nowrap text-center" *ngIf="!fromVehicleScreen">
                                                    <a class="btn btn-ico "
                                                        *ngIf="userRoleRightsDetails?.canDelete  else disabledDelete"
                                                        (click)="HardDeleteCustomer(item.id)"
                                                        ngbTooltip="{{'lblDelete' | translate}}"
                                                        tooltipClass="custom-revert">
                                                        <em class="far fa-trash-alt fa-lg"></em>
                                                    </a>
                                                    <ng-template #disabledDelete>
                                                        <a class="btn btn-ico disabled"
                                                            ngbTooltip="{{'lblDelete' | translate}}"
                                                            tooltipClass="custom-revert">
                                                            <em class="far fa-trash-alt fa-lg text-muted"></em>
                                                        </a>
                                                    </ng-template>
                                                </td>
                                            </tr>
                                        </ng-container>
                                        <ng-template #load_NotFound_Template>
                                            <tr>
                                                <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                                            </tr>
                                        </ng-template>
                                    </tbody>
                                </table>
                            </div>
                            <div class="card-footer">
                            </div>

                            <div class="p-3 bg-light" *ngIf="selectedCustomerId">
                                <div class="row">
                                    <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mb15">
                                        <button type="submit" *ngIf="selectedCustomerId" class="btn btn-primary mr-sm-2"
                                            translate (click)="selectedCustomer();"
                                            aria-label="Center Align">lblSelectCustomer</button>
                                    </div>
                                </div>
                            </div>

                            <div style="display: none; margin-top: 600px;">
                                <div class="container">
                                    <div class="row mb-15">
                                        <div class="col-12">
                                            <div class="row pl-5 pr-5 pt-5 pb-5">
                                                <div class="col-md-5">
                                                    <img class="brand" src="assets/images/autofacets.png"
                                                        onError="this.onerror=null; this.src='../../../assets/images/no-image-icon.png'"
                                                        height="70" style="width:300px" alt="">
                                                </div>

                                                <div class="col-md-7">
                                                    <div class="Invoice_title" style="float: left;">
                                                        <p class="font-weight-bold"
                                                            style="font-size:24px; color: black;">Customer Data
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <table class="table" id="customerPDF">
                                    <thead class="">
                                        <tr class="table-primary" style="font-size: large">
                                            <th scope="col" style="width:5%" translate style="font-weight: bold;">#</th>
                                            <th scope="col" style="width:9%" translate style="font-weight: bold;">
                                                lblCustomerNumber</th>
                                            <th scope="col" style="width:15%" translate style="font-weight: bold;">
                                                lblCustomerName</th>
                                            <th scope="col" style="width:17%" translate style="font-weight: bold;">
                                                lblCustomerType</th>
                                            <th scope="col" style="width:15%" translate style="font-weight: bold;">
                                                lblMobile</th>
                                            <th scope="col" style="width:17%" translate style="font-weight: bold;">
                                                lblEmail</th>
                                            <th scope="col" style="width:15%" translate style="font-weight: bold;">
                                                lblSource</th>
                                            <th scope="col" style="width:15%" translate style="font-weight: bold;">
                                                lblCity</th>
                                            <th scope="col" style="width:10%" translate style="font-weight: bold;">
                                                lblCountry</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <ng-container *ngIf="customerListPDF?.length>0; else load_NotFound_Template">
                                            <tr *ngFor="let item of customerListPDF; let i=index">
                                                <td>{{ i+1 }}</td>
                                                <td>
                                                    <ngb-highlight [result]="item.customerNo">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    <ngb-highlight [result]="item.customerName">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    <ngb-highlight [result]="item.customerType">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    <span *ngIf="item.mobileCode">+{{item.mobileCode}}</span>
                                                    <ngb-highlight [result]="item.mobileNo">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    <ngb-highlight [result]="item.email">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    <ngb-highlight [result]="item.sourceType">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    <ngb-highlight [result]="item.city">
                                                    </ngb-highlight>
                                                </td>
                                                <td>
                                                    <ngb-highlight [result]="item.country">
                                                    </ngb-highlight>
                                                </td>
                                            </tr>
                                        </ng-container>
                                        <ng-template #load_NotFound_Template>
                                            <tr>
                                                <td colspan="8" class="no-record" translate>lblNoRecordsFound</td>
                                            </tr>
                                        </ng-template>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <!-- soft deleted Customer listing end  -->
        </div>
    </div>
    <!-- Save Advance search section start -->
    <ng-template #SaveSearchContent let-modal>
        <div class="modal-header">
            <h2 class="modal-title" translate>lblSaveFilter</h2>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss(false)">

                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="modal-body p-0 ">
            <div class="popup-vcenter ">
                <div class="flgrow">
                    <div class="pad15">
                        <div class="form-row">
                            <div class='col-5'>
                                <label translate>lblSearchName</label><strong class="mlt6 required"> * </strong>
                                <div class="">
                                    <input class="form-control" type="text" name="SearchName" [formControl]="control"
                                        [(ngModel)]="saveSearchFilter.filterName" maxlength="200" autocomplete="off"
                                        placeholder="{{ 'lblEnterSearchName' | translate }}" />
                                    <div *ngIf="!saveSearchFilter.filterName && control.touched" style="color: red;"
                                        class="cst-validation-msg">
                                        <em class="fa fa-exclamation-circle" aria-hidden="true">&nbsp;&nbsp;</em><span
                                            translate>lblSearchNameRequired</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <hr />
                        <div class="form-row">
                            <div class="col-12">
                                <p class="title16 mb-2" translate>lblParameterValues</p>
                                <div class="row">
                                    <div class='col-4 mb-2' *ngFor="let search of saveSearchFilter.saveSearchArray">
                                        <div class="px-3">
                                            <em class="fa fa-chevron-right mr-2"></em>
                                            <span class="bold">{{search.searchColumnName | translate}}</span> :
                                            {{search.searchActualValue}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal-footer">
            <button type="submit" [disabled]="!saveSearchFilter.filterName" class="btn btn-primary mr-sm-2" translate
                (click)="control.markAsTouched();SaveAdvanceSearchFilter();" aria-label="Center Align">lblSave</button>
            <button (click)="modal.dismiss(false)" class="btn btn-secondary" aria-label="Center Align"
                translate>lblCancel</button>
        </div>
    </ng-template>
    <!-- Save Advance search section End -->